<template>
    <div class="tp-main-modal tp-modal tp-payment" :style="{
                '--backgroundColor': colors.backgroundColor,
                '--bodyBackgroundColor': colors.bodyBackgroundColor,
                '--borderColor': colors.borderColor,
                '--headerAndFooterBackgroundColor': colors.headerAndFooterBackgroundColor,
                '--headerTextColor': colors.headerTextColor,
                '--bodyTextColor': colors.bodyTextColor,
                '--footerTextColor': colors.footerTextColor,
                '--selectTextColor': colors.selectTextColor,
                '--hoveredBankBorderColor': colors.hoveredBankBorderColor}">
        <div class="tp-payment-container">
            <div>
                <div class="tp-payment-head">
                    <div class="tp-payment-brand">
                        <label>
                            {{ t("Payment service provided by") }}
                        </label>
                        <img :src="assets_url + '/img/tarkpay-logo.png'" alt="Tarkpay logo"/>
                    </div>
                </div>
            </div>

            <div class="tp-modal-text">
                <p>{{ text ? t(text) : t("Payment has been already paid") }}!</p>
            </div>
        </div>
    </div>
</template>

<script>
import settings from "../settings";
import {mapActions, mapMutations} from "vuex";
import {uiConfigurationsMixin} from '@/mixins/uiConfigurationsMixin';
export default {
    name: "payment-done-view",
    mixins: [uiConfigurationsMixin],
    data() {
        return {
            assets_url: settings.assets_url,
            text: "Payment has been already paid"
        };
    },
    async mounted() {
        const uri = window.location.search.substring(1);
        const params = new URLSearchParams(uri);

        if (params.get('payment_key')) {
            const response = await this.fetchUiConfigurations({
                paymentKey: params.get('payment_key'),
                isBulkPayment: params.get('is_bulk_payment')
            })

            if (response) {
                this.setUiConfigurations(response);
            }
        }

        if (params.get('inactive')) {
            this.text = "Payment expired";
        } else if(params.get('deadline')) {
            this.text = "Payment overdue";
        }
    },
    methods: {
        ...mapMutations(['setUiConfigurations']),
        ...mapActions(['fetchUiConfigurations'])
    }
};
</script>
<style lang="scss" scoped>
.bank-link-NDEAEE2X,
.bank-link-RIKOLV2X,
.bank-link-AGBLLT2X {
    img {
        transform: scale(1.5);
    }
}

.tp-modal {
    align-items: flex-start;
    background: white;
    max-width: 500px;
    padding-top: 30px;
    padding-bottom: 60px;
    margin: 50px auto;
    min-height: 100px;

    &-text {
        display: flex;
        justify-content: center;
        flex-direction: column;
        text-align: center;
        padding-top: 20px;
        padding-bottom: 20px;
    }
}

@import "../../../vue-embed/src/sass/reset.scss";
@import "../../../vue-embed/src/sass/_fonts.scss";
@import "../../../vue-embed/src/sass/_mixins.scss";
@import "../../../vue-embed/src/sass/_placeholders.scss";
@import "../../../vue-embed/src/sass/_payment-module.scss";
@import "../../../vue-embed/src/sass/_custom-styles.scss";
</style>
